export default __webpack_public_path__ + "static/media/samsung_stimuli_es.bb0f04df.mp4";